<template>
  <transition name="slide-fade">
    <div>
      <b-row class="mt-2 ,b-3">
        <b-col xl="3" md="3" sm="12">
          <b-form-select
              hidden="true"
              id="period"
              v-model="usersForm.group"
              :options="groupOption"
              value-field="key"
              size="sm"
              class="mt-2"
              text-field="label"
              @change="selectGroupList(usersForm.group)"
          ></b-form-select>
        </b-col>
        <b-col xl="7" md="7" sm="12"></b-col>
        <b-col xl="2" md="2" sm="12" class="text-right">
          <b-button
              v-if="!loadingStatus"
              data-cy="users-add-user-btn"
              size="sm"
              variant="success"
              class="mt-2 mb-3"
              v-b-modal.add-user
              v-b-tooltip.hover
              title="Add User"
          >
            <i class="fas fa-plus"></i> New
          </b-button>
        </b-col>
      </b-row>
      <div class="text-center w-100">
        <b-icon
            icon="three-dots"
            class="text-center"
            animation="cylon"
            font-scale="4"
            v-if="loadingStatus"
        ></b-icon>
      </div>

      <div class="mb-3" v-if="!loadingStatus">
        <b-row>
          <b-col cols="12" xl="8" lg="7" md="7" sm="6">
            <b-form-group
                label=""
                label-for="per-page-select"
                label-cols-sm="0"
                label-cols-md="0"
                label-cols-lg="0"
                label-align-sm="center"
                label-size="sm"
                class="mb-2 per-page-select"
            >
              <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
              <b-form-select
                  id="per-page-select"
                  class="diameter-report-select"
                  v-model="perPage"
                  :options="pageOptions"
                  size="sm"
                  v-on:input="changePageOption(perPage)"
              ></b-form-select>
            </b-form-group>
          </b-col>
          <b-col cols="12" xl="4" lg="5" md="5" sm="6" class="customer-table-select">
            <b-form-group
                label=""
                label-for="filter-input"
                label-align-sm="right"
                label-size="sm "
                class="mb-0 per-page-select"
            >
              <label for="filter-input" class="text-sm mr-2 mt-1">Search:</label>
              <b-input-group size="sm">
                <b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
            striped
            hover
            :items="tableData"
            :fields="tableColumns"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            head-variant="light"
            table-class="text-nowrap"
            class="data-management-table primary-table"
            sticky-header="true"
            thead-class="white"
            show-empty
            responsive
            small
            @filtered="onFiltered"
        >
          <template #cell(action)="row">
						<span
                v-if="portalAdmin || !row.item.group.includes('PORTAL_ADMIN')"
                class="nowrap"
            >
							<i
                  class="fas fa-pen-nib mr-3 cursor-pointer text-success"
                  v-b-modal.change-user
                  v-on:click="ChangeUserFunc(row.item)"
                  v-b-tooltip.hover
                  title="Edit User"
              ></i>
							<i
                  class="fas fa-trash-alt mr-3 cursor-pointer text-danger"
                  v-on:click="deleteUserInfo(row.item.userName)"
                  v-b-tooltip.hover
                  title="Delete User"
              ></i>
						</span>
          </template>
          <template #cell(group)="row">
						<span v-if="portalAdmin || !row.item.group.includes('PORTAL_ADMIN')">
							<tags-input
                  input-id="tags-pills"
                  v-model="row.item.group"
                  :userName="row.item.userName"
                  tag-type="danger"
                  size="sm"
                  no-add-on-enter
                  no-outer-focus
                  v-on:click="removeUserFromGroup(row.item.userName, tag)"
                  :closable="currentUser!==row.item.userName"
              >
							</tags-input>
						</span>
            <span v-else>
              <tags-input
                  input-id="tags-pills"
                  v-model="row.item.group"
                  :userName="row.item.userName"
                  tag-type="danger"
                  size="sm"
                  no-add-on-enter
                  no-outer-focus
                  :closable="false"
              >
							</tags-input>
            </span>
          </template>
        </b-table>
        <b-row class="mt-4">
          <b-col>
            <p class="ml-3 nowrap">{{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
          </b-col>
          <b-col>
            <b-pagination
                class="flex-fill-custom pr-4 ml-3 justify-content-end"
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                size="sm"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
      <b-modal
          centered
          size="lg"
          id="add-user"
          hide-footer
          title="Add New Portal User"
          cancel-title="Close"
          ok-variant="primary"
          ok-title="Submit"
      >
        <AddUserModal :existingUsers="existingUsernames"></AddUserModal>
      </b-modal>
      <b-modal
          centered
          size="lg"
          id="change-user"
          hide-footer
          title="Edit User"
          cancel-title="Close"
          ok-variant="primary"
          ok-title="Submit"
      >
        <ChangeUserModal></ChangeUserModal>
      </b-modal>
    </div>
  </transition>
</template>
<script>
import AddUserModal from "../../../Components/Add-User";
import ChangeUserModal from "../../../Components/Change-User";
import swal from "sweetalert2";
import TagsInput from "@/components/Inputs/TagsInput";
import handleResponse from "@/common/directive/handlResponse";
import pagination from "@/common/format/pagination";
import initService from "@/common/api-services/init-service";
import administratorService from "@/common/api-services/administrator-service";
import AdministratorService from "@/common/api-services/administrator-service";

export default {
  name: "UserList",
  components: {TagsInput, ChangeUserModal, AddUserModal},
  mounted() {
    //this.getSelectGroup();
    this.getUserListFunc();

    this.currentUser = initService.getAuthUserInfo().username;
    this.customer = initService.getCustomerInfo();
    this.portalAdmin = initService.getPortalAdminRole();
    //console.log(this.currentUser, this.portalAdmin);

    this.$root.$on("getUserList", () => {
      this.getUserListFunc();
    });

    this.$root.$on("removeUserFromGroup", res => {
      if (res.toString().includes(",")) {
        res = res.toString().split(",");
        this.removeUserFromGroup(res[0], res[1]);
      }
    });
  },
  data() {
    return {
      show: "Show Data",
      usersForm: {
        group: [], //'Select Group',
      },
      existingUsernames: [],
      groupOption: [],
      loadingStatus: false,
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      tableColumns: [
        {key: "action", label: "", sortDirection: "desc"},
        {key: "name", label: "Name", sortable: true, sortDirection: "desc"},
        {key: "userName", label: "Username", sortable: true, sortDirection: "desc"},
        {key: "group", label: "Roles", sortDirection: "desc"},
        //{key: 'enabled', label: 'Enabled', sortable: true, sortDirection: 'desc'},
        //{key: 'status', label: 'Status', sortable: true, sortDirection: 'desc'},
        {key: "email", label: "Email", sortable: true, sortDirection: "desc"},
        //{key: 'email_verified', label: 'Verified', sortable: true, sortDirection: 'desc'},
        {key: "phone_number", label: "Phone Number", sortable: true, sortDirection: "desc"},
        //{key: 'phone_number_verified', label: 'Verified', sortable: true, sortDirection: 'desc'},
        {key: "updated", label: "Updated", sortable: true, sortDirection: "desc"},
        {key: "created", label: "Created", sortable: true, sortDirection: "desc"},
      ],
      tableData: [],
      localData: [],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      currentUser: null,
      customer: null,
      portalAdmin: false
    };
  },
  methods: {

    removeUserFromGroup(username, group) {
      // console.log(typeof group);
      if (typeof group === "string") {
        group = [group];
      }
      AdministratorService.removeUserFromGroup(username, group).then(res => {
        // console.log(res) 
        let {type, msg} = handleResponse.apiResponse(res[0].data.message);
        this.$toast(msg, {type: type});
      })
      .catch(err => {
        console.error(err);
      });
    },

    changePageOption(page) {
      this.getTotalRows();
    },

    getSelectGroup() {
      administratorService.getGroupList().then(res => {
        if (res) {
          res.map((item, index) => {
            let child = {
              key: item.GroupName,
              label: item.GroupName,
            };
            this.groupOption.push(child);
          });
        }
      });
    },

    getUserListFunc() {
      this.tableData = [];
      this.loadingStatus = true;
      administratorService
          .getUserList()
          .then(res => {
            //console.log(res);
            this.loadingStatus = false;
            // console.log(res)
            if (res.hasOwnProperty("users")) {
              if (res.users.length > 0) {
                res.users.map(item => {
                  let groups = [];
                  let attr = [];
                  item.Attributes.map(attrItem => {
                    attr[attrItem.Name] = attrItem.Value;
                  });

                  item.Groups.map(groupItem => {
                    groups.push(groupItem.GroupName);
                  });
                  groups.sort();

                  this.existingUsernames.push(item.Username);

                  let child = {
                    name: attr["name"],
                    userName: item.Username,
                    group: groups,
                    enabled: item.Enabled,
                    status: item.UserStatus,
                    email: attr["email"],
                    email_verified: attr["email_verified"],
                    phone_number: attr["phone_number"],
                    phone_number_verified: attr["phone_number_verified"],
                    updated: new Date(item.UserLastModifiedDate).toLocaleDateString("en-US"),
                    created: new Date(item.UserCreateDate).toLocaleDateString("en-US"),
                  };
                  // if (child.email.includes(this.customer.toLowerCase()) || child.email.includes("dcc")) {
                  this.tableData.push(child);
                  // }
                });
                this.localData = this.tableData;
                this.totalRows = this.tableData.length;
              }
            } else if (typeof res === "object") {
              if (res.length > 0) {
                res.map(item => {
                  let groups = [];
                  let attr = [];
                  item.Attributes.map(attrItem => {
                    attr[attrItem.Name] = attrItem.Value;
                  });

                  item.Groups.map(groupItem => {
                    groups.push(groupItem.GroupName);
                  });
                  groups.sort();

                  this.existingUsernames.push(item.Username);

                  let child = {
                    name: attr["name"],
                    userName: item.Username,
                    group: groups,
                    enabled: item.Enabled,
                    status: item.UserStatus,
                    email: attr["email"],
                    email_verified: attr["email_verified"],
                    phone_number: attr["phone_number"],
                    phone_number_verified: attr["phone_number_verified"],
                    updated: new Date(item.UserLastModifiedDate).toLocaleDateString("en-US"),
                    created: new Date(item.UserCreateDate).toLocaleDateString("en-US"),
                  };
                  this.tableData.push(child);
                });
                this.localData = this.tableData;
                this.totalRows = this.tableData.length;
              }
            } else {
              this.localData = [];
              this.totalRows = 0;
            }
            this.getTotalRows();
          })
          .catch(err => {
            console.log(err);
          });
    },

    getTotalRows() {
      if (this.perPage > this.totalRows) {
        this.fromPage = this.totalRows;
      } else {
        this.fromPage = this.perPage;
      }
    },

    startPage() {
      return pagination.startPageFunc(this.currentPage, this.perPage);
    },

    lastPage() {
      return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows);
    },

    selectGroupList(list) {
      this.tableData = this.localData;
      let newChild = [];
      this.tableData.map(item => {
        if (item.group === list) {
          newChild.push(item);
        }
      });
      this.tableData = newChild;
      this.totalRows = this.tableData.length;
      this.paginationChanged(this.currentPage);
    },

    ChangeUserFunc(username) {
      setTimeout(() => {
        //show the Change-User.vue modal
        this.$root.$emit("ChangeUserOldData", username);
      });
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    deleteUserInfo(username) {
      swal.fire({
        title: `Users`,
        text: `Delete selected portal user? ${username}`,
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        customClass: {
						cancelButton: 'order-1 mr-3',
						confirmButton: 'btn btn-danger order-2',
        },
      }).then(result => {
        if (result.isConfirmed) {
          administratorService.deleteUser(username).then(res => {
            let {type, msg} = handleResponse.apiResponse(res);
            this.$toast(msg, {type: type});
            this.getUserListFunc();
          });
        }
      });
    },
  },
};
</script>
